import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { persistor, store } from './redux/store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import './i18n/config'
import './styles/index.scss'
import * as PdfJs from 'pdfjs-dist'
import { ConfigProvider } from 'antd'
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
PdfJs.GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js'
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConfigProvider
        theme={{
          components: {
            Button: {
              defaultBg: '#ededed'
            },
            Table: {
              cellFontSize: 16
            }
          }
        }}
      >
        <App />
      </ConfigProvider>
    </PersistGate>
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
